import * as React from 'react'
import cn from 'classnames'

import { ErrorText, IFormInput, Label } from '..'

import { ReactComponent as ArrowSvg } from './arrow.svg'
import styles from './select.module.scss'

export interface IOption {
  selected?: boolean
  text: string
  value: string
}

export interface ISelect<T> extends IFormInput<T> {
  options: IOption[]
  required?: boolean
  wrapperClassName?: string
}

function getSelectedText(options: IOption[]): string {
  const selected = options.find((option) => !!option.selected)
  if (selected) {
    return selected.text
  }
  return options[0].text
}

export const markSelected = (options: IOption[], selectedValue: string): IOption[] =>
  options.map((option) => {
    option.selected = option.value === selectedValue
    return option
  })

export default function Select<T>({
  errorCollapse = 'fixed',
  errorMessage = '',
  input,
  label = '',
  options,
  name,
  valid = 'unknown',
  required,
  wrapperClassName,
}: ISelect<T>) {
  if (typeof name !== 'string') {
    throw new TypeError('name must be a string')
  }

  const isInvalid = valid === 'invalid'

  return (
    <div className={cn(styles.root, wrapperClassName)}>
      {label && (
        <Label input={input} name={name}>
          {label}
        </Label>
      )}
      <div className={styles.selectWrapper}>
        {getSelectedText(options)}
        <ArrowSvg className={styles.arrow} />
        <select required={required} {...input.select({ name })} className={styles.select}>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.text}
            </option>
          ))}
        </select>
      </div>
      {(errorCollapse === 'fixed' || isInvalid) && <ErrorText>{isInvalid && errorMessage}</ErrorText>}
    </div>
  )
}
